import Vue from 'vue'
import App from './App.vue'
import store from './store';

import router from './router'//路由
import './assets/css/animate.min.css';
import './assets/css/bootstrap-icons.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/mfb.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import api from "@/api/index.js"; // 全局挂载请求
import {tool} from "@/utils/tool.js"; // 全局挂载请求

// import './styles/dark.scss'
import dragVerifyImgChip from '@/components/dragVerifyImgChip.vue';
Vue.component('drag-verify-img-chip', dragVerifyImgChip);

import footerModel from '@/components/footerModel.vue'
Vue.component('footerModel', footerModel) // 全局注册组件

import advertisement from '@/components/advertisement.vue'
Vue.component('advertisement', advertisement) // 全局注册组件
import footerBtn from '@/components/footerBtn.vue'
Vue.component('footerBtn', footerBtn) // 全局注册组件
import step from '@/components/step.vue'
Vue.component('step', step) // 全局注册组件
import suspension from '@/components/suspension.vue'
Vue.component('suspension', suspension) // 全局注册组件
import banner from '@/components/banner.vue'
Vue.component('banner', banner) // 全局注册组件
Vue.prototype.$api = api;//请求接口api
Vue.prototype.$tool = tool;//请求接口api
Vue.use(ElementUI);
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
// 设置全局前置守卫
